/**
 * Internal dependencies
 */
import Header from './header';
import Styles from './styles';
import Youtube from './youtube';

/**
 * 
 */
class Front {

	/**
	 * @type HTMLElement
	 */
	bodyElement = null;

	/**
	 * @type Document
	 */
	contextDocument = document;

	/**
	 * @type String
	 */
	currentBaseURL = '';

	/**
	 * @type Header
	 */
	header = null;

	/**
	 * @type String
	 */
	openCloseButtonClass = 'open-close-button';

	/**
	 * @type String
	 */
	openCloseIsOpenClass = 'is-open';

	/**
	 * @type String
	 */
	openCloseWrapperClass = 'open-close-wrapper';

	/**
	 * @type Styles
	 */
	styles = null;

	/**
	 * 
	 * @type Youtube
	 */
	youtube = null;

	/**
	 * 
	 */
	constructor()
	{
		this.init();
	}

	/**
	 * 
	 */
	init()
	{
		this.onAnchorLinkClick = this.onAnchorLinkClick.bind( this );
		this.onBlockArchiveItemsAdded = this.onBlockArchiveItemsAdded.bind( this );
		this.onDOMContentLoaded = this.onDOMContentLoaded.bind( this );
		this.onNewWindowLinkClick = this.onNewWindowLinkClick.bind( this );
		this.onOpenCloseButtonClick = this.onOpenCloseButtonClick.bind( this );
		this.onWindowResize = this.onWindowResize.bind( this );
		this.onWindowScroll = this.onWindowScroll.bind( this );
		this.onSliderManagerSetup = this.onSliderManagerSetup.bind( this );

		this.contextDocument.addEventListener( 'DOMContentLoaded', this.onDOMContentLoaded );
		window.addEventListener( 'resize', this.onWindowResize );
		window.addEventListener( 'scroll', this.onWindowScroll );
		window.addEventListener( 'wmuwpblocks/archive/itemsAdded', this.onBlockArchiveItemsAdded );
		window.addEventListener( 'wmuwpblocks/sliderManager/setup', this.onSliderManagerSetup );

		this.currentBaseURL = window.location.href.split( '#' )[0];

		this.header = new Header( this );
		this.styles = new Styles();
		this.youtube = new Youtube();
	}

	/**
	 * 
	 * @param {HTMLElement} contextElement 
	 */
	initOpenCloseButtons( contextElement = null )
	{
		if ( null === contextElement )
		{
			contextElement = this.bodyElement;
		}

		contextElement.querySelectorAll( `.${this.openCloseButtonClass}` ).forEach( ( buttonElement ) =>
		{
			buttonElement.addEventListener( 'click', this.onOpenCloseButtonClick );
		} );
	}

	/**
	 * @todo Voir ce qu'il faut scinder dans des fichiers séparés à terme.
	 * 
	 * @param {Event} event 
	 */
	onDOMContentLoaded( event )
	{
		if ( null === this.bodyElement )
		{
			this.bodyElement = this.contextDocument.querySelector( 'body' );
		}

		if ( this.bodyElement )
		{
			this.styles.setup();
			this.header.setup();
			this.youtube.maybeInitPlayers( this.bodyElement );

			/**
			 * Init header hide & seek
			 */
			if ( this.bodyElement.classList.contains( 'wmu-header-hide-and-seek' ) )
			{
				this.header.setupHideAndSeek();
			}
	
			/**
			 * New window links
			 */
			const newWindowLinkSelector = '.new-window, .social-navigation a, a[href*="://"]:not([href*="' + window.location.host + '"])';
			this.bodyElement.querySelectorAll( newWindowLinkSelector ).forEach( element => element.addEventListener( 'click', this.onNewWindowLinkClick ) );

			/**
			 * Anchor links
			 * 
			 * Scroll to anchor if link URL match the current page and the target element exist.
			 */
			const anchorLinkSelector = 'a[href*="#"], a[href="' + this.currentBaseURL + '"]';
			this.bodyElement.querySelectorAll( anchorLinkSelector ).forEach( ( element ) =>
			{
				const linkFullURL = element.getAttribute( 'href' );

				// Direct anchor link
				if ( linkFullURL.length > 0 && linkFullURL[0] === '#' )
				{
					element.addEventListener( 'click', this.onAnchorLinkClick );
				}
				else
				{
					const linkBaseURL = linkFullURL.split( '#' )[0];
	
					// Anchor link URL match the current page URL
					if ( this.currentBaseURL === linkBaseURL )
					{
						element.addEventListener( 'click', this.onAnchorLinkClick );
					}
				}
			} );

			/**
			 * Open/close buttons
			 */
			this.initOpenCloseButtons();
	
			/**
			 * Dispatch events
			 */
			window.dispatchEvent( new CustomEvent( 'resize' ) );
			window.dispatchEvent( new CustomEvent( 'scroll' ) );
		}
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onAnchorLinkClick( event )
	{
		const element = ( event.target.tagName && event.target.tagName.toLowerCase() == 'a' ) ? event.target : event.target.closest( 'a' );

		if ( ! element ) return;

		const linkFullURL = element.getAttribute( 'href' );
		let linkBaseURL = linkFullURL.split( '#' );
		const linkAnchorID = ( linkBaseURL.length > 1 ) ? linkBaseURL[1] : '';
		let targetScrollTop = 0;
				
		linkBaseURL = linkBaseURL[0];
		event.preventDefault();

		// 
		const openCloseWrapperElement = element.closest( `.${this.openCloseWrapperClass}` );

		if ( openCloseWrapperElement )
		{
			openCloseWrapperElement.classList.remove( this.openCloseIsOpenClass );
		}

		// Scroll to the top of the page
		if ( linkFullURL === this.currentBaseURL )
		{
			targetScrollTop = 0;
		}
		
		// Scroll to the target anchor element
		else
		{
			const targetElement = this.bodyElement.querySelector( `#${linkAnchorID}` );

			if ( targetElement )
			{
				targetScrollTop = targetElement.getBoundingClientRect().top + window.scrollY;
			}
		}

		window.scrollTo( { top: targetScrollTop, left: 0, behavior: 'smooth' } );
		history.pushState( {}, '', linkFullURL );
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onBlockArchiveItemsAdded( event )
	{
		if ( homothety )
		{
			homothety.update();
		}

		if ( event.detail && event.detail.item && event.detail.item.length )
		{
			event.detail.item.forEach( ( element ) =>
			{
				this.youtube.maybeInitPlayers( element );
			} );
		}
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onNewWindowLinkClick( event )
	{
		const linkElement = event.target;

		if ( linkElement.href )
		{
			event.preventDefault();
			window.open( linkElement.href );
			return false;
		}
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onOpenCloseButtonClick( event )
	{
		const wrapperElement = event.target.closest( `.${this.openCloseWrapperClass}` );

		if ( wrapperElement )
		{
			event.preventDefault();
			wrapperElement.classList.toggle( this.openCloseIsOpenClass );
			return false;
		}
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onSliderManagerSetup( event )
	{
		if ( homothety )
		{
			homothety.update();
		}
	}
	
	/**
	 * 
	 * @param {Event} event 
	 */
	onWindowResize( event )
	{
		this.header.checkHeight();

		if ( homothety )
		{
			homothety.update();
		}
	}

	/**
	 * @note Voir si on ajoute des classes comme :
	 * - wmu-scroll-bottom : bas de page atteint
	 * - wmu-scroll-first-content : bas du premier contenu atteint
	 * 
	 * @param {Event} event 
	 */
	onWindowScroll( event )
	{
		if ( null === this.bodyElement )
		{
			this.bodyElement = this.contextDocument.querySelector( 'body' );
		}
		
		const scrollTop = this.contextDocument.documentElement.scrollTop;

		if ( 0 === scrollTop )
		{
			this.bodyElement.classList.add( 'wmu-scroll-top' );
			this.bodyElement.classList.remove( 'wmu-scrolled' );
		}
		else
		{
			this.bodyElement.classList.remove( 'wmu-scroll-top' );
			this.bodyElement.classList.add( 'wmu-scrolled' );
		}
	}

}

export default Front;